import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setSectionsReload, setWorkflowApprover, snackbarMessage } from '../../core/actions';
import ConfirmationPopup from '../../core/controls/components/confirmationPopup';
import { GetData, PutData } from '../../core/modules/form/formsapi';
import { getEnvVariable } from '../environmentalList';
import Dropdown from '../../core/controls/components/dropdown';
import Label from '../../core/controls/components/label';


var inthis;

const extraProps = {
    transformProps: {
        label: 'name',
        value: 'value'
    },
}
class CWorkflow extends Component {
    constructor(props) {
        super(props);
        //  const { options,params } = props
        const { WorkflowId, SitePermitTypeId, ApplicationID, params } = props ? props : { SitePermitTypeId: 0, ApplicationID: 0 }

        this.state = {
            SitePermitTypeId: SitePermitTypeId,//this.props.apptypeId,
            WorkflowId: null,
            // ParentWorkflowId: 0,
            ApplicationID: ApplicationID,//this.props.applicationid,
            // siteID: 0,
            workflowOptions: [],
            workflowStatus: 0,
            isApprover: false,
            isAssigned: true,
            currentTaskAssigned: 0,
            workflowStage: '',
            workflowTask: {},
            isForceInspection: false,
            currentStatus: '',
            message: '',
            statusOpen: false,
            prevStatusVal: ''
        }
    }

    componentDidMount() {
        this.getworkflowId();
        inthis.props.setSectionsReload(true);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.WorkflowId !== this.state.WorkflowId)
            this.getworkflowId();
        if (prevProps.workflowreload !== this.props.workflowreload && this.props.workflowreload === true) {
            this.getworkflowId();
            this.props.setSectionsReload(false)
        }
    }

    //!== "undefined" && parseInt(workflowId) > 0 && inthis.props.edit
    getworkflowId = () => {
        inthis = this;
        var sourceURL = getEnvVariable('Sidebar') + `/api/Workflows/${inthis.props.ApplicationID}/CurrentWorkflow`;
        GetData(sourceURL, "").then(results => {
            if (results) {
                let workflowId = results.WorkflowId;
                if (workflowId)
                    inthis.setState({ WorkflowId: workflowId }, () => {
                        inthis.loadWorkflowObject(workflowId);
                    })
                else inthis.loadWorkflowObject();
            }
        })
    }

    reload = () => {
        const current = this.props.location.pathname;
        this.props.history.replace(`/reload`);
        setTimeout(() => {
            this.props.history.replace(current);
        });
    }

    registerWorkflowUser = (tworkflowId) => {

        if (window.workflowObj) {
            if (tworkflowId && tworkflowId > 0)
                var loadworkflowData = getEnvVariable('Application') + `/api/Workflows/ByWorkflowId/` + tworkflowId
            GetData(loadworkflowData, '').then(resp => {
                if (resp) {
                    if (resp.AssignedTo) {
                        let assignedToVal = resp.AssignedTo;
                        if (typeof assignedToVal === 'string' && assignedToVal.includes(',')) {
                            assignedToVal = assignedToVal.split(',')[0].trim();
                        }
                        window.workflowObj.data.initUser({ username: assignedToVal, roles: [resp.RoleName] });
                    }
                }
            })
        }
    }

    loadWorkflowObject(tworkflowId) {
        inthis = this;
        let tempWorkflowId = tworkflowId ? tworkflowId : this.state.WorkflowId
        if (tempWorkflowId && tempWorkflowId > 0) {
            try {
                //Verify the workflow access
                console.log("tworkflowId" + tworkflowId + "state tworkflowId" + this.state.WorkflowId)
                // if (inthis.props.accessPermissions.isAdmin) {
                //     var workflow = window.workflow;
                //     var target = getEnvVariable('WorkFlow');
                //     var source = getEnvVariable('MasterAdmin') + "/api";
                //     var workflowObj = new workflow({
                //         source: source, target: target,
                //         notifylink: "/workflow/notify",
                //         notify: function (d) { }
                //     });
                //     window.workflowObj = workflowObj;
                //     if (window.workflowObj.data && window.workflowObj.data.initUser) {
                //         inthis.registerWorkflowUser(tempWorkflowId);
                //     }
                // }
                if (window.workflowObj.data) {
                    window.workflowObj.data.getTasks(function (q) {
                        window.workflowObj.data.getFlow(tempWorkflowId, function (retFlow) {
                            var currFlow = retFlow.currflow;
                            if (q.length === 0) {
                                inthis.setState({ workflowStatus: currFlow.status, workflowOptions: currFlow.options, WorkflowId: tworkflowId ? tworkflowId : inthis.state.WorkflowId }, () => {
                                    inthis && inthis.props && inthis.props.handleFieldValue({ target: { value: '', name: 'WORKFLOW_STATUS', checked: false }, currentTarget: { dataset: null } })
                                });
                            } else {
                                //From currflow check assigneduserid (userid) and disable workflow dropdown.
                                var currTask = null;
                                for (var i = 0; i < q.length; i++) {
                                    var task = q[i];
                                    if (task.flowid === (tempWorkflowId && tempWorkflowId.toString())) {
                                        currTask = task;
                                        break;
                                    }
                                }
                                if (currTask !== null && currTask.approver) {
                                    inthis.props.setWorkflowApprover(true);
                                }
                                if (currTask !== null) {
                                    console.log(task.approver, task.investigator, 'task.investigator --- Inspection check');

                                    const ids = String(currTask.assignee).split(',').map(id => id.trim());

                                    console.log('IDs Array:', ids);
                                    console.log('User ID:', String(inthis.props.accessPermissions.userId));
                                    console.log('Result:', ids.includes(String(inthis.props.accessPermissions.userId)));
                                    var isAssignedVal = ids.includes(String(inthis.props.accessPermissions.userId));
                                    //isAssigned: currTask.assignee.includes(inthis.props.accessPermissions.userId), //(task.assignee === localStorage.username),//Compare with current loggedin user
                                    inthis.setState({
                                        workflowTask: currTask,
                                        isApprover: currTask.approver,
                                        isAssigned: isAssignedVal,
                                        workflowStatus: currFlow ? currFlow.status : '',
                                        workflowOptions: currFlow ? currFlow.options : [],
                                        currentTaskAssigned: currTask.assignee,
                                        workflowStage: currFlow ? currFlow.group : '',
                                        isForceInspection: currTask.investigator,
                                        WorkflowId: tworkflowId ? tworkflowId : inthis.state.WorkflowId
                                    }, () => {
                                        inthis && inthis.props && inthis.props.handleFieldValue({ target: { value: currFlow.status, name: 'WORKFLOW_STATUS', checked: false }, currentTarget: { dataset: null } })
                                    });
                                    console.log('New state', inthis.state);
                                } else {
                                    let isApprover = null;
                                    let Assignee = 0;
                                    let accessPermissionsuser = 0;
                                    let xml = retFlow.xml
                                    let regexp = /flowable:assignee="([A-Z]*[[a-z]*[0-9]*)" flowable:approver="([A-Z]*[[a-z]*[0-9]*)/g
                                    //var regexpr= new RegExp("(&lt;" + regexp + "&gt;)([A-Z]*[[a-z]*[0-9]*)(&lt;." + regexp + "&gt;)");
                                    let match = regexp.exec(xml);
                                    //console.log("regexpr :" ,regexp);
                                    //console.log("match :" ,match);
                                    while (match !== null) {
                                        // matched text: match[0]
                                        // match start: match.index
                                        // capturing group n: match[n]
                                        isApprover = match[2]
                                        Assignee = match[1]
                                        accessPermissionsuser = inthis.props.accessPermissions.userId;
                                        //console.log("isApprover :" ,isApprover);
                                        //console.log("Assignee :" ,Assignee);
                                        //console.log("accessPermissions :" ,inthis.props.accessPermissions.userId);
                                        //console.log("accessPermissions props :" ,inthis.props);
                                        //console.log("value :" ,inthis.props.value);
                                        //inthis.props.setWorkflowApprover(true);
                                        break
                                    }
                                    //Assignee = inthis.props.accessPermissions.userId === Assignee //Compare with current loggedin user
                                    if (Assignee == accessPermissionsuser && (isApprover == true || isApprover == 'true') && inthis.props.value === "Recommended") {
                                        //console.log("value :" ,inthis.props.value);
                                        //console.log("inside if :" ,Assignee);
                                        //console.log("accessPermissions :" ,inthis.props);
                                        inthis.props.setWorkflowApprover(true);
                                    }
                                    // console.log("assigne  :" ,Assignee, "accesspermision", inthis.props.accessPermissions.userId, 'approver',isApprover);
                                    //console.log('condition',Assignee == accessPermissionsuser && (isApprover == true || isApprover == 'true') && !inthis.props.value === "Started")
                                    inthis.setState({
                                        workflowStatus: currFlow.status,
                                        isApprover: isApprover,
                                        workflowOptions: currFlow.options,
                                        currentTaskAssigned: currFlow.userid,
                                        workflowStage: currFlow.group,
                                        isAssigned: false,
                                        WorkflowId: tworkflowId ? tworkflowId : inthis.state.WorkflowId
                                    }, () => {
                                        inthis && inthis.props && inthis.props.handleFieldValue({ target: { value: currFlow.status, name: 'WORKFLOW_STATUS', checked: false }, currentTarget: { dataset: null } })
                                    });
                                }
                            }
                        });
                    })
                }
            }
            catch (ex) {
                inthis.props.handleFieldValue({ target: { value: '', name: 'WORKFLOW_STATUS', checked: false } })

            }
        }
    }


    handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
    };



    hasInspection(e) {
        //Check application has any inspection
        var sourceURL = getEnvVariable('Application') + `/api/InspectionSimple/${this.state.ApplicationID}/Grid`;
        GetData(sourceURL, "").then(results => {
            console.log(results);
            if (results && results.data && Array.isArray(results.data) && results.data.length > 0) {
                this.changeWorkflowStatus(e);
            } else {
                inthis.props.snackbarMessage(`Inspection Check : Please add inspection to continue workflow`, 'error');
            }
        })
    }

    changeWorkflowCurrentStatus(tworkflowId) {
        inthis = this;
        let tempWorkflowId = tworkflowId ? tworkflowId : inthis.state.WorkflowId
        if (typeof window.workflowObj !== "undefined" && tempWorkflowId && tempWorkflowId > 0) {
            try {
                window.workflowObj.data.getTasks(function (q) {
                    window.workflowObj.data.getFlow(tempWorkflowId, function (retFlow) {
                        var currFlow = retFlow;
                        if (currFlow != null) {
                            if (currFlow.isComplete && currFlow.isComplete === true) {
                                let WorkflowCurrentStatusUpdateUrl = getEnvVariable('Sidebar') + `/api/Workflows/` + inthis.state.ApplicationID + "/" + `UpdateCurrentStatus/` + inthis.state.WorkflowId
                                PutData(WorkflowCurrentStatusUpdateUrl, null).then(rappes => {
                                    inthis.setState({}, () => {
                                        inthis.reload();
                                    })
                                })
                            }
                        }
                    })
                })
            }

            catch (ex) {
                inthis.props.handleFieldValue({ target: { value: '', name: 'WORKFLOW_STATUS', checked: false } })
            }
        }
    }

    changeWorkflowStatus(e) {
        inthis = this;
        let workflowChangeObj = { task: inthis.state.workflowTask, comment: "No Comment", action: e.target.value }
        //status changed to approved while workflow recommended
        let workflowStatusUpdateUrl = getEnvVariable('Application') + "/api/Application/UpdateWorkflow/" + this.state.SitePermitTypeId + "/" + this.state.ApplicationID + "?&status=" + e.target.value + "&workflowid=" + this.state.WorkflowId;
        if (e.target.value === "Recommended" || e.target.value === "Send Back" || e.target.value === "Not Recommended") {
            if (e.target.value === "Recommended") {
                let ApplicationStatusUpdateUrl = ""
                let invoiceurl = ""
                //Updated by venkatesh removed the approver check while recommending the workflow status

                // if (this.state.workflowTask.approver === true) {
                //     inthis.props.setWorkflowApprover(true);
                //     ApplicationStatusUpdateUrl = getEnvVariable('Application') + `/api/Application/UpdateStatus/` + this.state.SitePermitTypeId + "/" + this.state.ApplicationID + `?stage=Approved&isUpdateStatus=true`
                //     invoiceurl = getEnvVariable('Payment') + `Invoice/GenerateInvoice/` + this.state.ApplicationID
                // }
                // else if (this.state.workflowTask.issuer === true) {
                //     ApplicationStatusUpdateUrl = getEnvVariable('Application') + `/api/Application/UpdateStatus/` + this.state.SitePermitTypeId + "/" + this.state.ApplicationID + `?stage=Issued&isUpdateStatus=true`
                // }
                try {
                    //  workflowChangeObj.task.name = "Investigate";
                    inthis.props.snackbarMessage(`Please wait Workflow status is changing to ${e.target.value} `, 'info')
                    window.workflowObj.data.complete(workflowChangeObj, function (q) {
                        PutData(workflowStatusUpdateUrl, null).then(res => {
                            if (ApplicationStatusUpdateUrl !== "") {
                                PutData(ApplicationStatusUpdateUrl, null).then(rappes => {
                                    GetData(invoiceurl, "").then(invres => {
                                        // Handle invoice generation response
                                        inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully. An invoice has been generated for this request and Application approved.`, 'success')
                                        inthis.setState({ workflowStatus: e.target.value }, () => {
                                            inthis.reload();
                                            inthis.props.setSectionsReload(true)
                                            inthis.loadWorkflowObject()
                                            //inthis.changeWorkflowCurrentStatus(inthis.state.WorkflowId)
                                        }, () => {
                                            //call the function to update complete 
                                        })
                                    })
                                        .catch(err => {
                                            console.log("Error generating invoice:", err);
                                            inthis.props.snackbarMessage(`Failed to generate invoice for ${e.target.value}`, 'error');
                                        });
                                })
                            }
                            else {
                                inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                                inthis.setState({ workflowStatus: e.target.value }, () => {
                                    inthis.reload();
                                    inthis.props.setSectionsReload(true)
                                    inthis.loadWorkflowObject()
                                })
                            }

                        }).catch(ex => {
                            console.log("here workflow excep")
                            inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                            inthis.setState({ workflowStatus: e.target.value }, () => {
                                inthis.reload();
                                inthis.props.setSectionsReload(true)
                                inthis.loadWorkflowObject()
                            })
                            // inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error')
                        })
                        // inthis.setState({ workflowStatus: e.target.value }, () => {
                        //     inthis.props.setSectionsReload(true)
                        //     inthis.loadWorkflowObject()
                        // })
                    }, function (e) {
                        inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                        inthis.setState({ workflowStatus: e.target.value }, () => {
                            inthis.reload();
                            inthis.props.setSectionsReload(true)
                            inthis.loadWorkflowObject()
                        })
                        //inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error')
                    });
                } catch (e) { inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error') }

            }
            else {
                try {
                    inthis.props.snackbarMessage(`Please wait Workflow status is changing to ${e.target.value} `, 'info')
                    window.workflowObj.data.complete(workflowChangeObj, function (q) {
                        PutData(workflowStatusUpdateUrl, null).then(res => {
                            inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                            inthis.setState({ workflowStatus: e.target.value }, () => {
                                inthis.reload();
                                inthis.props.setSectionsReload(true)
                                inthis.loadWorkflowObject()
                            })
                        }).catch(ex => {
                            inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                            inthis.setState({ workflowStatus: e.target.value }, () => {
                                inthis.reload();
                                inthis.props.setSectionsReload(true)
                                inthis.loadWorkflowObject()
                            })
                            // inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error')
                        })
                        // inthis.setState({ workflowStatus: e.target.value }, () => {
                        //     inthis.props.setSectionsReload(true)
                        //     inthis.loadWorkflowObject()
                        // })
                    }, function (e) {
                        inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                        inthis.setState({ workflowStatus: e.target.value }, () => {
                            inthis.reload();
                            inthis.props.setSectionsReload(true)
                            inthis.loadWorkflowObject()
                        })
                        //inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error')
                    });
                } catch (e) { inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error') }
            }
        }

    }


    handleStatusClose = () => {
        this.setState({ statusOpen: false, currentStatus: "", prevStatusVal: '', message: '' });
    }

    //Permit approver - yes show only label
    //he is recommending, You are the permit approver,recommending will approve this Application - Are u sure u want to recommend
    //  he is not recommend ->You are the permit approver,Not recommending will deny the Application - Are u sure u want to not recommend
    //extender - yes
    //inspection needed - yes


    handleDropdownChange = (e) => {
        let prevVal = this.state.workflowStatus;
        let mgs = this.state.workflowStage === 'Permit Approver' ? `You are the permit approver, ${e.target.value} will ${e.target.value === 'Recommended' ? 'Approve' : "Deny"} Application.` : ""
        this.setState({
            statusOpen: true, prevStatusVal: prevVal, currentStatus: e, message: `${mgs} Are you sure to change the status to ${e.target.value}`
        }, () => {
            this.handleSelectChange(e);
            // call bpm request
        });
    }

    handleSelectChange = (e) => {
        if (this.state.isForceInspection)
            this.hasInspection(e);
        else
            this.changeWorkflowStatus(e);
    }

    handleStatusSubmit = () => {
        this.setState({ statusOpen: false, prevStatusVal: '', message: '' }, () => {
            this.handleSelectChange(this.state.currentStatus)
        });
    }

    render() {
        const { edit, value, tooltip } = this.props;
        let valueindex = 0;
        let newworkflowoptions = this.state.workflowOptions
        let removedworkflowoptions = ["Not Started", "Not Forwarded", "Waiting", "Approved", "Denied", "Forwarded"]
        if (this.state.workflowOptions && this.state.workflowOptions.length > 0) {
            newworkflowoptions = this.state.workflowOptions.filter(element => {
                if (!removedworkflowoptions.includes(element.name)) {
                    return element
                }
            });
            valueindex = this.state.workflowOptions.findIndex(x => x.value === (this.state.workflowStatus || value));
        }

        return (
            <div className="sketch_ToolBox_Widget">
                
                {/* <ConfirmationPopup value={this.state.statusOpen || false} onSubmit={this.handleStatusSubmit} onClose={this.handleStatusClose}
                title="Status Change" description={this.state.message || ""} /> */}
                {this.state.WorkflowId && parseInt(this.state.WorkflowId) > 0 ? (<>
                    {!edit ?
                        <Label value={this.state.workflowStatus} extraProps={extraProps} items={newworkflowoptions || []} label={'Workflow Status'} name={'WORKFLOW_STATUS'} changefieldto='DS' /> :
                        <Dropdown className="col-12" extraProps={extraProps} items={newworkflowoptions || []} handleFieldValue={(e) => this.handleDropdownChange(e)} value={this.state.workflowStatus} label={'Workflow Status'} name={'WORKFLOW_STATUS'}
                            disabled={!this.state.isAssigned} /> // //this.props.accessPermissions.isAdmin ||
                    }</>) : ''}


            </div>
            // <div className="sketch_ToolBox_Widget" >
            //     <ConfirmationPopup value={this.state.statusOpen || false} onSubmit={this.handleStatusSubmit} onClose={this.handleStatusClose}
            //         title="Status Change" description={this.state.message || ""} />
            //     {this.state.WorkflowId > 0 ? (
            //         <span >
            //             {edit &&
            //                 <FormControl className="col-sm-12" >
            //                     <InputLabel >{'Workflow Status'}</InputLabel>
            //                     <Select
            //                         disabled={(this.props.accessPermissions.isAdmin === "N" && !this.state.isAssigned)}
            //                         value={this.state.workflowStatus}
            //                         onChange={this.handleDropdownChange}
            //                         className="col-sm-12"
            //                     >
            //                         {newworkflowoptions.map(m => { return <MenuItem disabled={m.disabled} value={m.value}> {m.name}</MenuItem> })}
            //                     </Select>
            //                 </FormControl>
            //             }
            //             {!edit && <div>
            //                 <Typography variant={'caption'} className="fw-bold" >{'Workflow Status'}    < Tooltip title={tooltip ? tooltip : 'Workflow status'} placement="bottom-start" >
            //                     <HelpOutlineIcon fontSize="small" style={{ width: '0.8em' }} />
            //                 </Tooltip> </Typography><br />
            //                 <Typography variant={'body2'} className="text-secondary" color={'textPrimary'}> {(this.state.workflowOptions && this.state.workflowOptions[valueindex]) ? this.state.workflowOptions[valueindex].name : 'No Status'}  </Typography>
            //             </div>}
            //         </span>
            //     ) : (< div >
            //         <Typography variant={'caption'} className="text-secondary">{'Workflow Status'}    < Tooltip title={tooltip ? tooltip : 'Workflow status'} placement="bottom-start" >
            //             <HelpOutlineIcon fontSize="small" style={{ width: '0.8em' }} />
            //         </Tooltip> </Typography><br />
            //         <Typography variant={'body2'} className="fw-bold" color={'textPrimary'}>{'N/A'}   </Typography>
            //     </div>)
            //     }
            // </div>
        );
    }


    componentDidCatch(error, info) {
        console.log(error);
    }
}

const mapProps = state => {
    return {
        workflowreload: state.header && state.header.workflowreload,
        workflowApprover: state.header && state.header.workflowApprover
    }
}

const mapActions = dispatch => {
    return bindActionCreators({ snackbarMessage, setSectionsReload, setWorkflowApprover }, dispatch);
}



CWorkflow = connect(mapProps, mapActions)(CWorkflow)
export default withRouter(CWorkflow);


